export const en = {
  'shell.tagline': 'Mock Location Made Easy',
  'shell.closeMenu': 'Close menu',
  'shell.accountMenu': 'Account menu',
  'shell.expandSidebar': 'Expand sidebar',
  'shell.collapseSidebar': 'Collapse sidebar',
  'shell.mainNav': 'Main',
  'shell.openMenu': 'Open menu',
  'shell.welcome': 'Welcome back, {name}!',
  'shell.there': 'there',
  'shell.dashboardSubtitle':
    'Manage your mock locations, playlists, itineraries and more from one place.',
  'shell.searchLabel': 'Search locations, playlists, itineraries, articles',
  'shell.searchPlaceholder': 'Search locations, playlists, itineraries, articles...',
  'shell.searchResults': 'Search results',
  'shell.noMatches': 'No matches',
  'shell.pages': 'Pages',
  'shell.recent': 'Recent',
  'shell.notificationsUnread': 'Notifications, {count} unread',
  'shell.notifications': 'Notifications',
  'shell.viewAllNotifications': 'View all notifications',
  'shell.accountMenuNamed': 'Account menu, {name}',
  'shell.account': 'Account',
  'shell.logOut': 'Log out',
  'shell.goPremium': 'Go Premium',
  'shell.unlimitedCoins': 'Unlimited coins',
  'shell.unlimitedEverything': 'Unlimited everything',
  'shell.devicesLimit': 'Use on up to 3 devices',
  'shell.upgradeNow': 'Upgrade Now',
  'shell.themeToLight': 'Switch to light theme',
  'shell.themeToDark': 'Switch to dark theme',
  'shell.themeLightTitle': 'Light theme',
  'shell.themeDarkTitle': 'Dark theme',

  'nav.dashboard': 'Dashboard',
  'nav.dashboard.desc': 'Overview of locations, playlists, routes, and account activity.',
  'nav.stationary': 'Stationary Points',
  'nav.stationary.desc': 'Fixed mock locations saved on this account.',
  'nav.playlist': 'Playlists',
  'nav.playlist.desc': 'Ordered sets of mock locations.',
  'nav.itinerary': 'Itineraries',
  'nav.itinerary.desc': 'Create, edit and manage your saved routes.',
  'nav.articles': 'Articles',
  'nav.articles.desc': 'Guides for setup, playback, and sync.',
  'nav.joystick': 'Joystick Sessions',
  'nav.joystick.desc': 'Playback routes, stats, and saved joystick sessions.',
  'nav.history': 'Location History',
  'nav.history.desc': 'Places this account has mocked.',
  'nav.coins': 'Mock Coins',
  'nav.coins.desc': 'Complete breakdown of your coin usage across modules and activities.',
  'nav.devices': 'Manage devices',
  'nav.devices.desc': 'Review devices signed in to your MockLoc account.',
  'nav.backup': 'Backup & Sync',
  'nav.backup.desc': 'Cloud backup and sync status.',
  'nav.analytics': 'Analytics',
  'nav.analytics.desc': 'Understand your MockLoc activity, network usage and sync health.',
  'nav.whatsNew': "What's new in App",
  'nav.whatsNew.desc': 'Fresh updates, fixes, and improvements to MockLoc.',
  'nav.notifications': 'Notifications',
  'nav.notifications.desc': 'Sync, backup, and product alerts.',
  'nav.account': 'Account',
  'nav.account.desc': 'Profile, premium, and sign-in details.',
  'nav.help': 'Help & Support',
  'nav.help.desc': 'Track conversations and get help from the MockLoc team.',
  'nav.settings': 'Settings',
  'nav.settings.desc': 'Theme, language, and mobile app defaults.',

  'settings.back': 'Settings',
  'settings.backDefaults': 'Mobile app defaults',
  'settings.theme.shellTitle': 'Theme',
  'settings.theme.shellDesc': 'Text size, colors, light or dark, and font for this browser.',
  'settings.language.shellTitle': 'Language',
  'settings.language.shellDesc': 'Choose the language for this site.',
  'settings.defaults.shellTitle': 'Mobile app defaults',
  'settings.defaults.shellDesc': 'Defaults the phone app uses for maps, points, routes, and playback.',

  'settings.home.theme.title': 'Theme settings',
  'settings.home.theme.desc': 'Text size, colors, light or dark, and font for this browser.',
  'settings.home.language.title': 'Language settings',
  'settings.home.language.desc': 'Choose the language used for the menu, page titles, and settings.',
  'settings.home.defaults.title': 'Mobile app defaults',
  'settings.home.defaults.desc':
    'Map, stationary, playlist, itinerary, joystick, and player defaults from the phone app.',

  'language.lead': 'English (United States) is the default. Your choice is saved in this browser.',
  'language.searchLabel': 'Search languages',
  'language.searchPlaceholder': 'Search languages',
  'language.listLabel': 'Languages',
  'language.defaultBadge': 'Default',
  'language.empty': 'No languages match that search.',
  'language.previewLabel': 'Preview',
  'language.preview': 'Mock locations, playlists, and routes.',

  'theme.manager': 'Theme manager',
  'theme.lead':
    'Choose text size, color, light or dark, and font for this browser. 100% matches the screens as they are today. Samples here, and the rest of the site, update together.',
  'theme.resetAll': 'Reset all',
  'theme.previewKicker': 'Live preview',
  'theme.previewTitle': 'Mock locations',
  'theme.previewBold': 'Playlist ready',
  'theme.previewBody': 'Saved locations on this account.',
  'theme.previewHelp': 'Ordered sets of mock locations.',
  'theme.text.title': 'Text',
  'theme.text.lead':
    'Each role is one shared size. The sample shows that role. Sliders on this page stay a fixed size so they remain easy to use.',
  'theme.resetText': 'Reset text',
  'theme.whereLabel': 'Where it is used.',
  'theme.changesLabel': 'What it changes.',
  'theme.sizeAria': '{title} size',
  'theme.text.header.title': 'Header',
  'theme.text.header.sample': 'Stationary Points',
  'theme.text.header.where':
    'Page titles, hero headlines, empty-state titles, and large numbers such as coin balances.',
  'theme.text.header.changes': 'Text sized 20px and above.',
  'theme.text.bold.title': 'Bold',
  'theme.text.bold.sample': 'Go Premium',
  'theme.text.bold.where': 'Card titles, the brand name, section headings, and large buttons.',
  'theme.text.bold.changes': 'Text sized 15px to 18px.',
  'theme.text.normal.title': 'Normal',
  'theme.text.normal.sample': 'Saved locations on this account.',
  'theme.text.normal.where': 'Navigation labels, standard buttons, list titles, and short summaries.',
  'theme.text.normal.changes': 'Text sized 14px.',
  'theme.text.descriptive.title': 'Descriptive',
  'theme.text.descriptive.sample': 'Ordered sets of mock locations.',
  'theme.text.descriptive.where': 'Subtitles, helper text, badges, footers, and secondary lines.',
  'theme.text.descriptive.changes': 'Text sized 12px to 13px.',
  'theme.text.other.title': 'Other',
  'theme.text.other.sample': 'Updated 2 hours ago',
  'theme.text.other.where': 'Kickers, timestamps, chart labels, and captions.',
  'theme.text.other.changes': 'Text sized 9px to 11px. Marks under 9px stay fixed.',
  'theme.color.title': 'Color',
  'theme.color.lead':
    'Built-in colors stay different in light and dark until you choose one. Your choice is used in both themes. Colors saved on a point, playlist, or route stay as saved.',
  'theme.resetColors': 'Reset colors',
  'theme.colorAria': '{title} color',
  'theme.hexAria': '{title} hex',
  'theme.custom': 'Custom',
  'theme.builtin': 'Built-in',
  'theme.reset': 'Reset',
  'theme.color.primary.title': 'Primary',
  'theme.color.primary.where': 'Buttons, the active menu item, links, and brand purple.',
  'theme.color.primary.changes': 'Solid purple, pale purple text, and soft purple backgrounds.',
  'theme.color.accent.title': 'Accent',
  'theme.color.accent.where': 'Gold highlights on login, articles, and callout badges.',
  'theme.color.accent.changes': 'Brand gold and pale gold fills, including small illustration highlights.',
  'theme.color.info.title': 'Info',
  'theme.color.info.where': 'Blue status, informational links, and info marks.',
  'theme.color.info.changes': 'The blue used for information across light and dark.',
  'theme.color.success.title': 'Success',
  'theme.color.success.where': 'Synced, complete, and positive status.',
  'theme.color.success.changes': 'Green status text and success marks.',
  'theme.color.warning.title': 'Warning',
  'theme.color.warning.where': 'Alerts, coin marks, and premium highlights.',
  'theme.color.warning.changes': 'Amber warnings and the gold used on coins.',
  'theme.color.danger.title': 'Danger',
  'theme.color.danger.where': 'Errors, removals, and the unread dot.',
  'theme.color.danger.changes': 'Red error text and destructive actions.',
  'theme.mode.title': 'Theme',
  'theme.mode.lead': 'Same light and dark choice as the button in the top bar.',
  'theme.mode.group': 'Theme',
  'theme.mode.dark': 'Dark',
  'theme.mode.light': 'Light',
  'theme.mode.darkHint': 'Dim surfaces and light text.',
  'theme.mode.lightHint': 'Bright surfaces and dark text.',
  'theme.font.title': 'Font',
  'theme.font.lead':
    'One family is used across the site. Marketing headlines return to Plus Jakarta Sans when Inter is selected. The weights below are the ones the interface already uses.',
  'theme.resetFont': 'Reset font',
  'theme.font.group': 'Font',
  'theme.font.sample': 'Mock locations made easy',
  'theme.font.inter.note': 'Font the site uses today. Regular through Black are loaded.',
  'theme.font.google-sans.note': 'Regular file covers 400 and 500. Bold file covers 600 through 900.',
  'theme.font.helvetica.note': 'Uses Helvetica on this device, then Helvetica Neue, then Arial.',
  'theme.font.arial.note': 'Regular and Bold are installed faces. Other weights are synthesized.',
  'theme.weight.regular': 'Regular',
  'theme.weight.medium': 'Medium',
  'theme.weight.semibold': 'Semibold',
  'theme.weight.bold': 'Bold',
  'theme.weight.extrabold': 'Extra bold',
  'theme.weight.black': 'Black',
  'theme.weight.sample': 'Mock locations, playlists, and routes',
  'theme.face.gsRegular': 'Google Sans Regular',
  'theme.face.gsBold': 'Google Sans Bold',
  'theme.face.arialRegular': 'Arial Regular',
  'theme.face.arialBold': 'Arial Bold',
  'theme.face.arialSynth': 'Synthesized from Arial',
  'theme.face.helveticaRegular': 'Helvetica Regular',
  'theme.face.helveticaOther': 'Helvetica or synthesized',
  'theme.face.inter': 'Inter {weight}',

  'defaults.browserChip': 'This browser',
  'defaults.syncNote':
    'Saved in this browser for now. The phone app will use these defaults after sync is connected.',
  'defaults.sectionDefaults': 'App defaults',
  'defaults.sectionDefaultsDesc': 'Set defaults for a faster and smoother experience',
  'defaults.sectionPlayer': 'Player',
  'defaults.sectionPlayerDesc': 'Overlay and playback settings',
  'defaults.reset': 'Reset',
  'defaults.map.title': 'Google Map',
  'defaults.map.desc': 'How new maps open by default',
  'defaults.stationary.title': 'Stationary',
  'defaults.stationary.desc': 'Defaults for new map points',
  'defaults.playlist.title': 'Playlist',
  'defaults.playlist.desc': 'Defaults for new playlist pins',
  'defaults.itinerary.title': 'Itinerary',
  'defaults.itinerary.desc': 'Defaults for new route segments',
  'defaults.joystick.title': 'Joystick',
  'defaults.joystick.desc': 'Defaults for joystick sessions',
  'defaults.player.title': 'Player',
  'defaults.player.desc': 'Controls for overlay and mock playback players',
  'defaults.summary.zoom': 'zoom {n}',
  'defaults.summary.playerAll': 'All overlays on',
  'defaults.summary.playerOff': 'Overlays off',
  'defaults.summary.playerSome': '{on} of 4 on',
  'defaults.section.location': 'Location context',
  'defaults.section.map': 'Map',
  'defaults.section.camera': 'Camera',
  'defaults.section.history': 'History',
  'defaults.section.search': 'Search',
  'defaults.section.view': 'Map',
  'defaults.section.playlist': 'Playlist',
  'defaults.section.motion': 'Movement',
  'defaults.section.style': 'Style',
  'defaults.section.appearance': 'Appearance',
  'defaults.section.overlay': 'Overlay player',
  'defaults.actual.title': 'Your actual location',
  'defaults.actual.desc': 'Used for place search while mocking',
  'defaults.actual.empty': 'Not saved yet',
  'defaults.actual.emptyHint': 'Allow location and open the app with mocking off to capture it.',
  'defaults.actual.refresh': 'Update now',
  'defaults.actual.pending': 'The phone saves this location. Sync is not connected yet.',
  'defaults.mapTheme.title': 'Map theme',
  'defaults.mapTheme.desc': 'Look of new map screens',
  'defaults.mapTheme.group': 'Map theme',
  'defaults.zoom.title': 'Default zoom level',
  'defaults.zoom.desc': 'Starting zoom for new maps',
  'defaults.tilt.title': 'Default camera tilt',
  'defaults.tilt.desc': 'Camera angle on map screens',
  'defaults.degrees': '{n}°',
  'defaults.meters': '{n} m',
  'defaults.seconds': '{n} sec',
  'defaults.kilometers': '{n} km',
  'defaults.speedValue': '{n} {unit}',
  'defaults.range.zoomMin': '10',
  'defaults.range.zoomMax': '20',
  'defaults.range.tiltMin': '0°',
  'defaults.range.tiltMax': '65°',
  'defaults.range.accuracyMin': '0 m',
  'defaults.range.accuracyMax': '300 m',
  'defaults.range.searchMin': '3 km',
  'defaults.range.searchMax': '50 km',
  'defaults.range.timeMin': '0 sec',
  'defaults.range.timeMax': '600 sec',
  'defaults.range.plAccuracyMin': '0 m',
  'defaults.range.plAccuracyMax': '500 m',
  'defaults.range.joyAccuracyMin': '1 m',
  'defaults.range.joyAccuracyMax': '100 m',
  'defaults.range.itinAccuracyMin': '1',
  'defaults.range.itinAccuracyMax': '100',
  'defaults.theme.silver': 'Silver',
  'defaults.theme.silverDesc': 'Clean light-grey styling, easy on the eyes in daylight.',
  'defaults.theme.night': 'Night',
  'defaults.theme.nightDesc': 'Dark map colors for low-light use and night sessions.',
  'defaults.theme.retro': 'Retro',
  'defaults.theme.retroDesc': 'Warm vintage tones with a classic map feel.',
  'defaults.theme.standard': 'Standard',
  'defaults.theme.standardDesc': 'Classic Google Maps colors with familiar greens and blues.',
  'defaults.accuracy.title': 'Default GPS accuracy',
  'defaults.accuracy.desc': 'Precision used for new history points',
  'defaults.nameFormat.title': 'Date format',
  'defaults.nameFormat.desc': 'Default name for stationary points',
  'defaults.nameFormat.dialogTitle': 'Choose point name format',
  'defaults.nameFormat.dialogSubtitle': "Preview uses today's date. Pick a compact format for new points.",
  'defaults.nameFormat.group': 'Date format',
  'defaults.search.title': 'Search radius',
  'defaults.search.stationary': 'Nearby results prioritized around your pin',
  'defaults.search.playlist': 'Nearby results prioritized around map center',
  'defaults.search.itinerary': 'Nearby results prioritized around map center',
  'defaults.tray.title': 'Tray height',
  'defaults.tray.stationaryDesc': 'Visible panel size on the map',
  'defaults.tray.playlistDesc': 'Visible playlists panel on the map',
  'defaults.tray.group': 'Tray height',
  'defaults.tray.small': 'Small',
  'defaults.tray.medium': 'Medium',
  'defaults.tray.large': 'Large',
  'defaults.view.historyTitle': 'History view',
  'defaults.view.historyDesc': 'How saved points are shown',
  'defaults.view.playlistTitle': 'Playlist view',
  'defaults.view.playlistDesc': 'How saved playlists are shown',
  'defaults.view.group': 'View',
  'defaults.view.list': 'List',
  'defaults.view.grid': 'Grid',
  'defaults.time.title': 'Time per item',
  'defaults.time.desc': 'Wait time before moving to the next pin',
  'defaults.plAccuracy.title': 'Accuracy per item',
  'defaults.plAccuracy.desc': 'GPS precision applied to each playlist pin',
  'defaults.speed.title': 'Default speed',
  'defaults.speed.desc': 'Playback speed for new route segments',
  'defaults.unit.title': 'Speed unit',
  'defaults.unit.itineraryDesc': 'Display speeds as km/h or mph across the itinerary module',
  'defaults.unit.group': 'Speed unit',
  'defaults.unit.kmh': 'km/h',
  'defaults.unit.mph': 'mph',
  'defaults.itinAccuracy.title': 'Accuracy',
  'defaults.itinAccuracy.desc': 'GPS precision for new route segments',
  'defaults.color.title': 'Route color',
  'defaults.color.desc': 'Line color for new routes',
  'defaults.color.group': 'Route color',
  'defaults.joySpeed.title': 'Default speed',
  'defaults.joySpeed.desc': 'Used as the starting speed when you create a new joystick session',
  'defaults.joyUnit.desc': 'Display and control joystick speeds as km/h or mph',
  'defaults.joyAccuracy.title': 'Default GPS accuracy',
  'defaults.joyAccuracy.desc':
    'Used as the starting GPS accuracy when you create a new joystick session',
  'defaults.joyName.title': 'Date format',
  'defaults.joyName.desc': 'Default name for new joystick sessions',
  'defaults.joyName.dialogTitle': 'Choose session name format',
  'defaults.marker.title': 'Default marker',
  'defaults.marker.desc':
    'Used when you create a new joystick session. You can still change it per session.',
  'defaults.marker.group': 'Default marker',
  'defaults.marker.maps': 'Maps',
  'defaults.marker.car': 'Car',
  'defaults.marker.waze': 'Waze',
  'defaults.polyline.title': 'Default polyline color',
  'defaults.polyline.desc': 'Default color for the route drawn during a joystick session.',
  'defaults.polyline.group': 'Polyline color',
  'defaults.overlay.stationary.title': 'Stationary',
  'defaults.overlay.stationary.desc':
    'Floating player when stationary mocking continues in the background',
  'defaults.overlay.playlist.title': 'Playlist',
  'defaults.overlay.playlist.desc':
    'Floating player when playlist mocking continues in the background',
  'defaults.overlay.itinerary.title': 'Auto Itinerary',
  'defaults.overlay.itinerary.desc':
    'Floating player when itinerary mocking continues in the background',
  'defaults.overlay.joystick.title': 'Joystick',
  'defaults.overlay.joystick.desc': 'Floating joystick when the session continues in the background',
  'defaults.format.dayShort': 'Day & date · 12h',
  'defaults.format.fullDay': 'Full date · 12h',
  'defaults.format.shortDayYear': 'Day, date, year · 24h',
  'defaults.format.dayMonthYear': 'Date, year · 12h',
  'defaults.format.eu': 'EU date · 24h',
  'defaults.format.us': 'US date · 12h',
  'defaults.format.iso': 'ISO date · 24h',
  'defaults.format.timeFirst': 'Time first · 24h',
  'defaults.format.monthFirst': 'Month first · 24h',
  'defaults.format.withSeconds': 'With seconds · 12h',
  'defaults.close': 'Close',
} as const;

export type MessageKey = keyof typeof en;
